// extracted by mini-css-extract-plugin
export default {"loadingSkeleton":"G7a501f"};